import { Box, Button, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export {
  Columns,
  Controls,
  Field,
  FieldLabel,
} from "~/feature/chart/components/ChartDialog/ChartDialog.styles";

export const CounterRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: theme.spacing(0.5),
  marginTop: theme.spacing(0.5),
}));

export const Counter = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "$over",
})<{ $over: boolean }>(({ $over, theme }) => ({
  color: $over ? theme.palette.error.main : theme.palette.text.secondary,
  fontWeight: $over ? 700 : 400,
}));

export const InfoIcon = styled("span")(({ theme }) => ({
  display: "inline-flex",
  fontSize: 16,
  color: theme.palette.text.secondary,
}));

export const HashtagsField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
}));

export const Share = styled(Box)(({ theme }) => ({
  display: "grid",
  alignContent: "start",
  gap: theme.spacing(2),
  minWidth: 0,
}));

export const PostButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 700,
  padding: theme.spacing(1.25, 2),
  borderRadius: 999,
}));
